export default "__VITE_ASSET__ARVO0qkX__"